import * as z from "zod/v4";
export const ContentTypeSchema = z.enum([
    "UNSPECIFIED",
    "PRODUCT",
    "PRODUCT_GROUP",
    "ORDER_ID",
    "ORDER_NAME",
    "ORDER_NUMBER",
]);
export const ProductIdentifierSchema = z.enum([
    "UNSPECIFIED",
    "PRODUCT_ID",
    "PRODUCT_SKU",
    "VARIANT_ID",
]);
const CtidSchema_ = z.object({
    id: z.string(),
    userCreated: z.boolean(),
    selected: z.boolean(),
});
export const CtidSchema = CtidSchema_;
const GoogleAdsCtidsSchema_ = z.object({
    ctids: z.record(z.string(), CtidSchema),
});
export const GoogleAdsCtidsSchema = GoogleAdsCtidsSchema_;
/**
 * How a Meta/TikTok/Snapchat destination gets its browser pixel events: through
 * the merchant's own GTM container (absent reads as GTM) or fired directly by
 * Contextual's tag runtime. Omit it on update to leave the stored value alone.
 */
export const TagDeliverySchema = z.enum(["GTM", "DIRECT"]);
const IntegrationMetadataSchema_ = z.object({
    contentType: ContentTypeSchema,
    productIdentifier: ProductIdentifierSchema,
    googleAdsCtids: GoogleAdsCtidsSchema.optional(),
    tagDelivery: TagDeliverySchema.optional(),
});
export const IntegrationMetadataSchema = IntegrationMetadataSchema_;
//# sourceMappingURL=metadata.js.map